import React, {
  useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { LayoutContext } from '@/components/Layout';
import cx from '@/utils/cx';
import useStyle from './style';

const FloatingContent = ({
  id,
  relatedId,
  children,
  className,
  ...rest
}) => {
  const { scrollTop, scrollHeight, layoutHeight } = useContext(LayoutContext);
  const [visible, setVisible] = useState(!relatedId);
  const classes = useStyle();

  let relatedEl = null;
  const isInViewport = () => {
    if (!relatedEl) {
      relatedEl = document.querySelector(`#${relatedId}`);
      if (!relatedEl) {
        return false;
      }
    }
    return (
      scrollTop < ((relatedEl || {}).offsetTop || 0)
    );
  };

  if (relatedId) {
    useEffect(() => {
      if (scrollHeight && layoutHeight + 50 <= scrollHeight) {
        setVisible(
          !isInViewport(),
        );
      }
    }, [scrollTop]);
  }

  return (
    <div
      {...rest}
      className={cx(
        classes.floatingContent,
        className,
        visible ? 'show' : 'hide',
      )}
      id={relatedId ? `${relatedId}-related` : id}
    >
      {children}
    </div>
  );
};

FloatingContent.propTypes = {
  id: PropTypes.string,
  relatedId: PropTypes.string,
};

FloatingContent.defaultProps = {
  id: undefined,
  relatedId: undefined,
};

export default FloatingContent;
